import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  exp: number;
  [key: string]: any;
}

/**
 * JWT 토큰을 디코드합니다.
 * @param token JWT 토큰
 * @returns 디코드된 토큰 페이로드
 */
export const decodeToken = (token: string): DecodedToken | null => {
  try {
    return jwtDecode<DecodedToken>(token);
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null;
  }
};

/**
 * 토큰이 지정된 일수 내에 만료되는지 확인합니다.
 * @param token JWT 토큰
 * @param days 확인할 일수 (기본값: 3일)
 * @returns 토큰이 지정된 일수 내에 만료되면 true
 */
export const isTokenExpiringSoon = (token: string, days: number = 3): boolean => {
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) {
    return false;
  }

  const now = Date.now() / 1000; // 현재 시간 (초)
  const expirationTime = decoded.exp;
  const daysInSeconds = days * 24 * 60 * 60;
  
  // 만료 시간까지 남은 시간이 지정된 일수보다 적으면 true
  return (expirationTime - now) <= daysInSeconds;
};

/**
 * 토큰이 만료되었는지 확인합니다.
 * @param token JWT 토큰
 * @returns 토큰이 만료되었으면 true
 */
export const isTokenExpired = (token: string): boolean => {
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) {
    return true;
  }

  const now = Date.now() / 1000;
  return decoded.exp < now;
};